export default {
  title: 'Bienvenue',
  subtitle: 'Connectez-vous pour gérer votre compte et vos commandes',
  benefits: {
    earn_points: {
      title: 'Gagnez des points à chaque commande',
      description: 'Cumulez des points et débloquez des récompenses exclusives',
    },
    get_deals: {
      title: 'Recevez des remises exclusives',
      description: 'Utilisez vos points pour obtenir des articles gratuits',
    },
    redeem_points: {
      title: 'Échangez vos points contre des repas gratuits',
      description: 'Accédez aux promotions réservées aux membres',
    },
  },
};
